import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { usePartnerKeyStatisticsTable } from "Partner/Modules/Statistics/Components/Tables/usePartnerKeyStatisticsTable";
import { usePartnerStatisticsFilter } from "Partner/Modules/Statistics/Hooks/usePartnerStatisticsFilter";
import { PartnerStatisticsFilterWidget } from "Partner/Modules/Statistics/Widgets/PartnerStatisticsFilterWidget";
import { PageContainer } from "Shared/Components/Container";
import { Table } from "Shared/Components/Table/index";
import { ButtonGroup, Stack, Typography } from "@mui/material";

const partnerStatisticsResource = Resources.base.partner.statistics;

export const PartnerStatisticsPage = () => {
	const { t } = useResource();
	const filter = usePartnerStatisticsFilter();
	const tableOptions = usePartnerKeyStatisticsTable(filter);
	return (
		<PageContainer
			title={t(partnerStatisticsResource.title)}
			description={t(partnerStatisticsResource.description)}
		>
			<Stack
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
			>
				<Typography variant="h2" mb={2}>
					{t(partnerStatisticsResource.title)}
				</Typography>
				<ButtonGroup
					size="small"
					variant="contained"
					aria-label="Basic button group"
				>
					<PartnerStatisticsFilterWidget />
				</ButtonGroup>
			</Stack>
			<Table tableOptions={tableOptions} />
		</PageContainer>
	);
};
